// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_weIlJ","col_640":"index_col_640_TYI4j","col_300":"index_col_300_WNtDG","col_455_l":"index_col_455_l_ldN6S","col_455_r":"index_col_455_r_csKC0"};